import { lang } from '@umu/ukit-lang';
import React, { memo, useState } from 'react';
import { classSet } from '@umu/umu-dom';
import { IKeywordItem, AI_KEYWORD_RULE } from '@umu/umu-types';
interface IProps {
    data: IKeywordItem;
    matchRule?: AI_KEYWORD_RULE;
}

import './keyWordItem.scss';
export const KeyWordItem = memo(({ data, matchRule }: IProps) => {
    const [fold, setFold] = useState(true);
    const synonyms = (data.synonyms || []).filter((v) => v.trim());
    const hasSynonyms = synonyms.length > 0;
    const isHit = data.count > 0;

    const onFold = () => {
        setFold(!fold);
    };

    const renderSynonyms = () => {
        return synonyms.map((synonym, i) => {
            return <div key={i} className="synonym-item umu-text-clamp clamp-1">{synonym}</div>;
        });
    };

    const synonymsStyle = {
        height: fold ? '0' : `${synonyms.length * 41}px`,
    };

    const foldClass = classSet({
        'icon-fold': true,
        'fold': fold,
        'unfold': !fold,
        'no-synonyms': !hasSynonyms,
    });

    let result = String(data.count);
    if (matchRule == AI_KEYWORD_RULE.AI) {
        result = isHit ? lang('命中') : lang('未命中');
    }
    return (
        <div className={`keyword-dash-item ${isHit ? 'hit' : ''}`}>
            <div className="keyword">
                <i className={foldClass} onClick={onFold}></i>
                <div className="word umu-text-clamp clamp-1">{data.word}</div>
                <div className="hit-result">{result}</div>
            </div>
            <div className="synonyms" style={synonymsStyle}>
                {renderSynonyms()}
            </div>
        </div>
    );
});
